import { NgModule } from '@angular/core';
import { ButtonDirective } from './button.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { RadioGroupDirective } from './radio-group.directive';
import { ClickStopPropagation } from './stop-click-propagation.directive';
import { BlockOnClickEvent } from './block-on-click-event.directive';

@NgModule({
  declarations: [
    ButtonDirective,
    RadioGroupDirective,
    ClickOutsideDirective,
    ClickStopPropagation,
    BlockOnClickEvent,
  ],
  imports: [],
  exports: [
    ButtonDirective,
    RadioGroupDirective,
    ClickOutsideDirective,
    ClickStopPropagation,
    BlockOnClickEvent,
  ],
})
export class DirectivesModule {}
